export default "__VITE_ASSET__CrKRLf5h__"